import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import Admissionleft from './Admissoinleft';
import { Container, Row, Col, Button,Table } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';
import Scholarshipleft from '../Scholarships/Scholarshipleft'

function Main() {

    const [datesOpen, setDatesOpen] = useState(true);
    const [guidelinesOpen, setGuidelinesOpen] = useState(false);
    
    
    const handleClick = (event) => {
        setDatesOpen(false);
        setGuidelinesOpen(false);       
        event(true);
    }

    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-4'>                        
                        <Scholarshipleft activeIndex={0} />
                    </Col>

                    <Col md={8} className='c-right text-center'>
                        
                        <div className="c-heading">
                            <h3>Scholarships for UG Students (B.Tech)</h3> <br />
                        </div>


                        
                        <Row className='mb-5'>
                            {/* /backup xs={6} sm={4} md={3} lg={3}/ */}
                            <Col xs={6} sm={6} md={6} lg={6} className="mb-3">
                                <Button className='btn-sm'
                                    onClick={() => handleClick(setDatesOpen)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={datesOpen}>
                                    Eligibilty criteria & Amount of scholarship
                                </Button>
                            </Col>

                            <Col xs={6} sm={6} md={6} lg={6} className="mb-3">
                                <Button className='btn-sm '
                                    onClick={() => handleClick(setGuidelinesOpen)}
                                    aria-controls="c-guidelines"
                                    aria-expanded={guidelinesOpen}>
                                    Apply online
                                </Button>
                            </Col>

                        </Row>


                        {/*dates */}
                    <div>
                        {datesOpen && <Fade in={datesOpen}>
                                <div className='lower-content'>
                                <p className="fw-bold"> <span className="glowing-text">The deadline to apply for Institute Scholarships has been extended till 25.09.2024.</span></p> 

                                    <Table className='table table-bordered mb-40'>
                                        <thead>
                                            <tr>
                                                <th colSpan={4} rowSpan={2} className='c-noformat'>Scholarships for UG Students (B.Tech)</th>
                                            </tr>
                                            <tr></tr>
                                            <tr>
                                                <th colSpan={4} className='c-noformat'>Eligibility Criteria & Amount of Scholarship</th>
                                            </tr>
                                  
                                            <tr>
                                                <th>S.No.</th>
                                                <th>Scholarships</th>
                                                <th>Eligibility</th>
                                                <th>Amount of scholarship</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>Merit-cum-Means Scholarship</td>
                                                <td>
                                                    Available for 25% of students admitted. Parents annual income not exceeding Rs. 4.50 lakhs. Renewal of scholarship every semester is subject to a minimum GPA of 5.0 in the previous semester.
                                                </td>
                                                <td>Rs. 1,000/- per month plus exemption of tuition fee per semester.</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td>Institute Free Studentship</td>
                                                <td>
                                                    Available for 10% of students admitted. Parents annual income not exceeding Rs. 4.50 lakhs. Renewal of scholarship every semester is subject to a minimum GPA of 5.0 in the previous semester.
                                                </td>
                                                <td>Exemption from payment of tuition fee per semester.</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>Institute SC/ST Scholarship</td>
                                                <td>
                                                    Parents annual income not exceeding Rs. 4.50 lakhs. Renewal of scholarship every semester is subject to a minimum GPA of 5.0 in the previous semester.
                                                </td>
                                                <td>Rebate of Rs. 8000/- in Mess charges, exemption of hostel seat rent, and pocket allowance of Rs. 250/- per month.</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    
                                  
                            </div>
                        </Fade>
                    }
                    </div>


                        {/*Guidelines*/}
                        
                    <div>
                            {guidelinesOpen && <Fade in={guidelinesOpen}>
                                <div className='c-lineheight2dot5 text-left'>
                                  
                                    <h4 className="mb-3">Apply Online</h4>
                                     <p>
                                       To Apply Online : <Link to="https://iittp.plumerp.co.in/prod/iittirupati/" target="_blank;" className="c-link">Click Here</Link>
                                    </p>
                                    <p>
                                       User Manual      : <Link to="https://files.iittp.ac.in/pdfs/announcements/2024/Institute_Scholarship_User_Manual_2024.pdf" target="_blank;" className="c-link">Click Here</Link>
                                    </p>
                                            
                            </div>
                        </Fade>
                    }
                </div>
            </Col>
        </Row>
    </Container>
        </section>
    );
}

export default Main;
